import Vue from 'vue';
import Chrome from 'vue-color/src/components/Chrome.vue';

Vue.component('color-picker', Chrome);
